import { json_headers, request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

export interface MessageArchive {
  id: string;
  notificationType: string;
  channel: string;
  sentAt: string | null;
  deliveredAt: string | null;
  openedAt: string | null;
  clickedAt: string | null;
  bouncedAt: string | null;
}

export interface MessageArchivesResponse {
  resultCount: number;
  totalCount: number;
  result: Array<MessageArchive>;
}

async function requestGetMessageArchives(
  userId: string,
  offset: number,
  limit: number,
  signal?: AbortSignal,
): Promise<MessageArchivesResponse> {
  if (!userId) {
    throw new Error('missing userId');
  }

  const url = makeCustomerCommunicationV1URL(
    `/users/message-archives?userId=${encodeURIComponent(userId)}&offset=${offset}&limit=${limit}`,
  );

  return request(url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers: json_headers,
    signal
  });
}

export default requestGetMessageArchives;
